export default __webpack_public_path__ + "static/media/warning.70e9e10e.svg";